// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".photo[data-v-48541d98]{padding-bottom:125%;background:no-repeat 50%/cover}h4[data-v-48541d98]{font-size:30px}@media (max-width:767.98px){h4[data-v-48541d98]{font-size:20px}}", ""]);
// Exports
module.exports = exports;
